export default __webpack_public_path__ + "static/media/Vol5Issue1.d0a2fbb5.png";